<template>
  <div class="flag_manage" >
    <el-divider content-position="left">目标进度</el-divider>
    <div class="changeHeight m-tabs-content">
      <el-row type="flex" >
        <el-col :span="2"   class="tr m-label text_right">选择日期</el-col>
        <el-col :span="4">
          <div>
            <el-date-picker
              v-model="value1"
              type="month"
              size="mini"
              format="yyyy 年 MM 月"
              value-format="yyyy-MM"
              @change="pickerDataChange"
              placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="2"  :offset="2" class="tr m-label text_right">选择角色</el-col>
        <el-col :span="4" >
          <el-select
            v-model="role"
            placeholder="请选择角色"
            size="mini">
            <el-option
              v-for="(item, index) in rolesNames"
              :key="index"
              :label="item.role_name"
              :value="item.id" >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" :offset="6" class="tr">
          <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
          <el-button type="danger" size="mini" @click="handleCloseSearch">清除</el-button>
        </el-col>
      </el-row>
    </div>
    <el-row class="mb-10" style="margin-top: 0">
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">云上总分配：{{totals.consult_cloud}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">套餐总分配：{{totals.consult_combo}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">单品总分配：{{totals.consult_item}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">云上总完成：{{totals.cloud_count}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">套餐总完成：{{totals.combo_count}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">单品总完成：{{totals.item_count}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">云上设置总目标：{{totals.target_cloud}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">套餐设置总目标：{{totals.target_combo}}</span></el-col>
    </el-row>
    <el-row class="mb-10" style="margin-top: 0">
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">云上总退单数量：{{totals.cloud_refund_count}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">套餐总退单数量：{{totals.combo_refund_count}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">单品总退单数量：{{totals.item_refund_count}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">合计退单数量：{{totals.all_refund_count}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">云上总退单金额：{{totals.cloud_refund_money}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">套餐总退单金额：{{totals.combo_refund_money}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">单品总退单金额：{{totals.item_refund_money}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">合计退单金额：{{totals.all_refund_money}}</span></el-col>
    </el-row>
    <el-row class="mb-10" style="margin-top: 0">
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">云上完成率：{{totals.cloud_rate}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">套餐完成率：{{totals.combo_rate}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">单品完成率：{{totals.item_rate}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">云上总提成：{{totals.cloud_royalty}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">套餐总提成：{{totals.combo_royalty}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">单品总提成：{{totals.item_royalty}}</span></el-col>
      <el-col :span="3" style="display: flex"><span class="count"  style="display: inline-block; width: 4rem;">合计提成金额：{{totals.total_royalty}}</span></el-col>
    </el-row>
    <el-row class="mb-10" style="margin-top: 0">
      <el-col :span="24" style="display: flex">
        <span class="count">目标进度：本月累计 {{leftCombos.monthDays}} 天，剩余 {{leftCombos.leftDays}} 天，按目前进度，云上今天必须做 <span style="color: red">{{leftCombos.avgClouds}}</span> 个，云上总计还差 <span style="color: red">{{leftCombos.leftCloud}}</span> 个，套餐今天必须做 <span style="color: red">{{leftCombos.avgCombos}}</span> 个，套餐总计还差 <span style="color: red">{{leftCombos.leftCombo}}</span> 个，才能完成本月目标。</span>
      </el-col>
    </el-row>
    <el-table :data="pageData" size="medium" max-height="500">
      <el-table-column prop="username" label="姓名" width="120" fixed></el-table-column>
      <el-table-column label="当月云上情况">
        <el-table-column prop="consult_cloud" label="云上分配目标" width="120"></el-table-column>
        <el-table-column prop="target_cloud" label="本月云上目标" width="120"></el-table-column>
        <el-table-column prop="cloud_count" label="本月云上完成" width="120"></el-table-column>
        <el-table-column prop="cloud_rate" label="本月云上完成率" width="130"></el-table-column>
      </el-table-column>
      <el-table-column label="当月套餐情况">
        <el-table-column prop="consult_combo" label="套餐分配目标" width="120"></el-table-column>
        <el-table-column prop="target_combo" label="本月套餐目标" width="120"></el-table-column>
        <el-table-column prop="combo_count" label="本月套餐完成" width="120"></el-table-column>
        <el-table-column prop="combo_rate" label="本月套餐完成率" width="130"></el-table-column>
      </el-table-column>
      <el-table-column label="当月单品情况">
        <el-table-column prop="consult_item" label="单品分配目标" width="120"></el-table-column>
        <el-table-column prop="item_count" label="本月单品完成" width="120"></el-table-column>
      </el-table-column>
      <el-table-column label="当月提成情况">
        <el-table-column prop="cloud_royalty" label="本月云上提成" width="120"></el-table-column>
        <el-table-column prop="combo_royalty" label="本月套餐提成" width="120"></el-table-column>
        <el-table-column prop="item_royalty" label="本月单品提成" width="120"></el-table-column>
        <el-table-column prop="total_royalty" label="本月总提成" width="120"></el-table-column>
      </el-table-column>
      <el-table-column label="当月退单情况">
        <el-table-column prop="cloud_refund_count" label="本月云上退单数量" width="140"></el-table-column>
        <el-table-column prop="combo_refund_count" label="本月套餐退单数量" width="140"></el-table-column>
        <el-table-column prop="item_refund_count" label="本月单品退单数量" width="140"></el-table-column>
        <el-table-column prop="all_refund_count" label="本月总退单数量" width="140"></el-table-column>
      </el-table-column>
      <el-table-column label="当月退款情况">
        <el-table-column prop="cloud_refund_money" label="本月云上退款金额" width="140"></el-table-column>
        <el-table-column prop="combo_refund_money" label="本月套餐退款金额" width="140"></el-table-column>
        <el-table-column prop="item_refund_money" label="本月单品退款金额" width="140"></el-table-column>
        <el-table-column prop="all_refund_money" label="本月总退款金额" width="140"></el-table-column>
      </el-table-column>
      <el-table-column label="当月达标情况">
        <el-table-column prop="over" label="本月超额天数" width="120"></el-table-column>
        <el-table-column prop="ok" label="本月合格天数" width="120"></el-table-column>
        <el-table-column prop="reach" label="本月达标天数" width="120"></el-table-column>
        <el-table-column prop="not" label="本月不合格天数" width="140"></el-table-column>
      </el-table-column>
      <el-table-column label="当月线索领取放弃情况">
        <el-table-column prop="person_get" label="个人领取" width="120"></el-table-column>
        <el-table-column prop="allot_get" label="公司分配" width="120"></el-table-column>
        <el-table-column prop="give_up" label="本月总放弃" width="120"></el-table-column>
        <el-table-column prop="current_day_give_up" label="本月领取本月放弃" width="140"></el-table-column>
      </el-table-column>
      <el-table-column label="当月线索沟通情况">
        <el-table-column prop="communicat" label="本月领取本月沟通" width="140"></el-table-column>
        <el-table-column prop="execute_rate" label="线索沟通率" width="120"></el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'flag_manage',
  data () {
    return {

      role: '',
      totals: [],
      leftCombos: [],
      year_month: '',
      percentNum: '',
      count: '',
      consult: [],
      cluesNum: '',
      cluesIndex: 0,
      FlagManage: [],
      FlagManageMonth: [],
      OperationRecord: [],
      ContactDrawer: false,
      search: '',
      value1: '',
      roles: [],
      options: [],
      ConversionPeople: [],
      rolesNames: [],
      activities: [],
      highSearch: {
        dateTime: '',
        uid: []
      },
      optionProps: {
        value: 'id',
        label: 'Provincial',
        children: 'son'
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      pageOptionMonth: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      dialogVisible3: false,
      activeName: 'first',
      combo: [],
      items: [],
      tabData: [],
      couldMealItem: {},
      selectMonth: '',
      selectMonthId: null
    }
  },
  computed: {
    pageData: function () {
      return this.FlagManage
    },
    pageDataMonth: {
      get: function () {
        return this.FlagManageMonth
      }
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.tabData.length
      this.pageOption.currentPage2 = 1
    }
  },
  methods: {
    handleSelectMonth (val) {
      this.selectMonth = val
      this.handleFlagDetailMethods(this.selectMonthId)
    },
    handleFlagDetail (id) {
      this.ContactDrawer = true
      this.selectMonthId = id
      this.handleFlagDetailMethods(id)
    },

    sortChange (column) {
      if (column.order === 'descending') {
        this.handelGetOrders(
          this.value1,
          this.role
        )
      } else if (column.order === 'ascending') {
        this.handelGetOrders(
          this.value1,
          this.role
        )
      } else {
        this.handelGetOrders(
          this.value1,
          this.role
        )
      }
    },
    getAllStatData () {
      this.$axios.post('/api/threadstat/flag_plan_list', {
        year_month: this.year_month,
        role: this.role
      })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.FlagManage = data.data.list
            this.rolesNames = data.data.roles
            this.totals = data.data.totals
            this.leftCombos = data.data.leftCombos
          }
        })
    },
    pickerDataChange (val) {
      if (!val) {
        this.year_month = ''
      } else {
        this.year_month = val
      }
    },
    handleSearch () {
      this.getAllStatData()
    },
    handleCloseSearch () {
      this.year_month = ''
      this.role = ''
      this.getAllStatData()
    }
  },
  mounted () {
    this.getAllStatData()
  }
}
</script>

<style scoped lang="stylus">
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  @import '~styles/icon.styl'
  .el-drawer__wrapper >>> .el-drawer
    overflow-y: auto
  .el-drawer__wrapper >>> .el-drawer__header span {
    color: #5789F4;
    font-size: 0.36rem;
    font-weight: 400;
  }
  .flag_manage
    marginLeft()
    .count_style
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
  .tr
    text-align: right
  .m-tabs-content
    overflow-y auto
    padding 0 .4rem
    box-sizing border-box
    .m-label
      line-height: .64rem
    .text_right
      text-align left
    .el-row
      margin-bottom: .4rem
  .flag_manage >>> .el-table__header th
    color: #333333
    background-color: #ECF4FF
  /*.clues_manage >>> .el-table__header thead .is-hidden*/
  /*  color: red*/
  /*  background-color: #ECF4FF*/
  /*  font-size 16px*/
  .mb-10
    margin-bottom: .2rem
    margin-top: 0.4rem
  .mt-10
    margin-top: .2rem
  .level
    display flex
    align-items center
    position relative
    padding-right .32rem
    img
      width .32rem
      height .30rem
    .el-icon-question
      margin-left: .1rem
      color: #409EFF
      position absolute
      top 0
      right 0
      cursor pointer
  .el-select, .el-cascader
    width: 100%
  .count
    padding-left: .2rem
    line-height: .56rem
  .el-position
    position relative
    .dot
      display inline-block
      width 0.1rem
      height 0.1rem
      border-radius 50%
      margin-right 0.1rem
      position absolute
      top 0
      left -.2rem
      bottom 0
      margin auto
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .changeHeight
    padding .2rem
    margin-top .4rem
  .el-collapse
    border-bottom 0
    border-top 0
  .el-collapse >>> .el-collapse-item__header
    color: #4C87FC
    font-weight bold
  .el-collapse >>> .el-collapse-item__arrow
    color: #4C87FC
  .el-collapse >>> .el-collapse-item__content
    padding-bottom 0
  .el_dialogs >>> .el-dialog__body
    padding-left 0
    padding-right 0
  .el_dialogs >>> .el-dialog__header
    padding 0

  .block
    height 6rem
    overflow-y auto
    padding-top .2rem
    padding-left .2rem
    box-sizing border-box

    .time_right
      width 100%
      margin-top .4rem
      overflow hidden
      word-break break-all
      white-space normal
  .el-timeline-item__node--large
    width .4rem
    height .4rem
  /*滚动条整体样式*/
  ::-webkit-scrollbar{
    width: .1rem;/*竖向滚动条的宽度*/
    height: 10px;/*横向滚动条的高度*/
  }
  ::-webkit-scrollbar-thumb{/*滚动条里面的小方块*/
    background: #cdcdcd;
    border-radius: 5px;
  }
  ::-webkit-scrollbar-track{/*滚动条轨道的样式*/
    background: #f8f8f8;
    border-radius: 5px;
  }
  .el-date-editor
    width: 100% !important

</style>



// WEBPACK FOOTER //
// src/pages/flag_plan/flag_plan.vue